module.exports = __webpack_public_path__ + "img/button-center-white.82215b4.png";